"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.TELEPHONE_NUMBER_VALIDATION_PATTERN = exports.UUID_VALIDATION_PATTERN = exports.EMAIL_VALIDATION_PATTERN = exports.PatternPlaceholders = exports.DateFormats = exports.SALUTATION_OPTIONS = exports.MIME_TYPE_REGEX = exports.FILE_NAME_REGEX = exports.UUID_REGEX = exports.SHORT_DATE_REGEX = exports.TIMEZONE_OFFSET_REGEX = exports.URL_REGEX = exports.TELEPHONE_NUMBER_REGEX = exports.EMAIL_REGEX = exports.ALLOWED_MEDIA_MIME_TYPES = exports.ALLOWED_CSV_TYPES_EXTENSIONS = exports.ALLOWED_MEDIA_EXTENSIONS = exports.ALLOWED_VIDEOS_TYPES_EXTENSIONS = exports.ALLOWED_IMAGES_TYPES_EXTENSIONS = void 0;
const csvTypes = ["csv"];
const imageTypes = ["png", "jpeg", "jpg", "gif"];
const videoTypes = ["mp4", "mov"];
const mediaTypes = [...imageTypes, ...videoTypes];
exports.ALLOWED_IMAGES_TYPES_EXTENSIONS = Object.freeze(imageTypes);
exports.ALLOWED_VIDEOS_TYPES_EXTENSIONS = Object.freeze(videoTypes);
exports.ALLOWED_MEDIA_EXTENSIONS = Object.freeze(mediaTypes);
exports.ALLOWED_CSV_TYPES_EXTENSIONS = Object.freeze(csvTypes);
exports.ALLOWED_MEDIA_MIME_TYPES = Object.freeze([
    ...imageTypes.map((type) => `image/${type}`),
    ...videoTypes.map((type) => `video/${type}`),
]);
exports.EMAIL_REGEX = /^(([^\s"(),.:;<>@[\\\]]+(\.[^\s"(),.:;<>@[\\\]]+)*)|(".+"))@((\[(?:\d{1,3}\.){3}\d{1,3}])|(([\dA-Za-z-]+\.)+[A-Za-z]{2,}))$/;
exports.TELEPHONE_NUMBER_REGEX = /^\+*\d{9,12}$/;
exports.URL_REGEX = new RegExp('^(http|https)://[^ "]+$');
exports.TIMEZONE_OFFSET_REGEX = /([+-]\d{2}|[+-]\d{2}:\d{2})$/;
exports.SHORT_DATE_REGEX = /^\d{4}-\d{2}-\d{2}/;
exports.UUID_REGEX = /^[\da-f]{8}-[\da-f]{4}-4[\da-f]{3}-[89ab][\da-f]{3}-[\da-f]{12}$/i;
exports.FILE_NAME_REGEX = new RegExp(`(?!^).(${exports.ALLOWED_MEDIA_EXTENSIONS.join("|")})$`, "i");
exports.MIME_TYPE_REGEX = new RegExp(`(${exports.ALLOWED_MEDIA_MIME_TYPES.join("|")})$`, "i");
exports.SALUTATION_OPTIONS = ["Mr", "Mrs", "Ms", "Other"];
var DateFormats;
(function (DateFormats) {
    DateFormats["time"] = "HH:mm:ssxxx";
    DateFormats["short"] = "yyyy-MM-dd";
    DateFormats["long"] = "yyyy-MM-dd'T'HH:mm:ssxxx";
    DateFormats["datetime"] = "yyyy-MM-dd HH:mm:ss";
    DateFormats["datetimeWithAMPM"] = "dd/MM/yyyy hh:mm aaa";
    DateFormats["localDayName"] = "eeee";
    DateFormats["isoDayName"] = "iiii";
    DateFormats["timeWithoutTz"] = "HH:mm:ss";
})(DateFormats = exports.DateFormats || (exports.DateFormats = {}));
var PatternPlaceholders;
(function (PatternPlaceholders) {
    PatternPlaceholders["EMAIL"] = "example@example.com";
    PatternPlaceholders["MIME_TYPE"] = "image/jpeg";
    PatternPlaceholders["CSV_TYPE"] = "text/csv";
    PatternPlaceholders["SHORT_DATE"] = "yyyy-MM-dd";
    PatternPlaceholders["LONG_DATE"] = "yyyy-MM-dd'T'HH:mm:ssxxx";
    PatternPlaceholders["TIME"] = "HH:mm:ssxxx";
    PatternPlaceholders["DATE_TIME"] = "yyyy-MM-dd HH:mm:ss";
    PatternPlaceholders["URL"] = "http://example.com";
    PatternPlaceholders["FILENAME"] = "testImage.jpeg";
    PatternPlaceholders["UUID"] = "xxxxxxxx-xxxx-xxxx-xxxx-xxxxxxxxxxxx";
    PatternPlaceholders["NUMBER"] = "1";
    PatternPlaceholders["STRING"] = "Some text";
    PatternPlaceholders["BOOLEAN"] = "true";
    PatternPlaceholders["AUTH_TOKEN"] = "Bearer <JWT_TOKEN>";
    PatternPlaceholders["TELEPHONE_NUMBER"] = "";
})(PatternPlaceholders = exports.PatternPlaceholders || (exports.PatternPlaceholders = {}));
exports.EMAIL_VALIDATION_PATTERN = Object.freeze({
    regex: exports.EMAIL_REGEX,
    name: "email",
    placeholder: PatternPlaceholders.EMAIL,
});
exports.UUID_VALIDATION_PATTERN = Object.freeze({
    regex: exports.UUID_REGEX,
    name: "UUID",
    placeholder: PatternPlaceholders.UUID,
});
exports.TELEPHONE_NUMBER_VALIDATION_PATTERN = Object.freeze({
    regex: exports.TELEPHONE_NUMBER_REGEX,
    name: "telephone_number",
    placeholder: PatternPlaceholders.TELEPHONE_NUMBER,
});
//# sourceMappingURL=utils.js.map